/**
 * Redux form requires that each form have a unique name
 * (and it's good practice), so we'll use this function
 * to get one from the selected parent sequence id,
 * and the given template.
 *
 * @param  {string} options.sequenceId      - Sequence Id
 * @param  {string} options.templateId      - Template Id
 * @return {string}                         - Generated form name
 */
export function getTemplateFormStateName({
    sequenceId,
    templateId,
}: {
    sequenceId: string;
    templateId: string;
}) {
    return `sequences.${sequenceId}.emailTemplates.${templateId}`;
}
